import { render, staticRenderFns } from "./ProjectFilesDetail.vue?vue&type=template&id=1ef3f1fd&scoped=true&"
import script from "./ProjectFilesDetail.vue?vue&type=script&lang=ts&"
export * from "./ProjectFilesDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3f1fd",
  null
  
)

export default component.exports